export default {
    data() {
        return {
            colors: {
                planning: {
                    target: '#00c9ff',
                    timeSpentWithinTarget: '#0acf97',
                    timeSpent: '#cfccc9',
                    overTime: '#dc3545'
                },
                downTimes:{
                     reasons:'#242A33'  //'#DD872E's:'#242A33'
                },
                jobProgress: {
                    finishedJob: '#7a7979',
                    readyOnTime: '#00c9ff',
                    readyLate: '#dc3545',
                    readyEarly: '#65d76b',
                    notReadyAndLate: '#e0e0e0',
                    annotationColor: '#46b700'
                },
                producedPerActivity: {
                    finishedJob: '#7a7979',
                    annotationColor: '#46b700'

                }
            }
        }
    }

}